import { hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { ReactRelayContext } from 'react-relay/legacy';
import serverVars from 'server-vars';
import SellerApplicationWrapper from '../sellerApplication/SellerApplicationWrapper';
import { SellerApplicationConfirmation } from '../sellerApplication/SellerApplicationConfirmation';
import { sellerApplicationRoot } from '../sellerApplication/sellerApplicationRoot';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import * as tracking from 'dibs-tracking';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const variables = serverVars.get('relayVariables');
const operation = createOperationDescriptor(getRequest(sellerApplicationRoot), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    if (serverVars.get('isConfirmation')) {
        hydrateRoot(
            document.getElementById('js-root'),
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <SellerApplicationConfirmation deviceType={serverVars.get('deviceType')} />
            </IntlProvider>
        );
    } else {
        hydrateRoot(
            document.getElementById('js-root'),
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <ReactRelayContext.Provider
                    value={{
                        environment,
                        variables: snapshot.variables || {},
                    }}
                >
                    <SellerApplicationWrapper viewer={snapshot.data.viewer} />
                </ReactRelayContext.Provider>
            </IntlProvider>
        );
    }
    tracking.trackPageview();
});
